import Box from '@mui/material/Box';

export default function LoadingOverlay({ children, sx }) {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 1,
        color: '#fff',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
